import React from 'react';
import {Link} from 'react-router-dom';

export default class Migalha extends React.Component{    
    render(){

        return (
            <div className="boxMigalha">
                <div className="limite">
                    <div className="boxLinksMigalhas">
                        Você está em:

                                <a href="/" title="Programa Anjos da Unoeste" className="lkMigalha ">Programa Anjos da Unoeste</a>
                                <span className="sepMigalha">|</span>
                                <Link to="/Cadastro" title="FICHA DE INSCRIÇÃO" className="lkMigalha pagAtual">FICHA DE INSCRIÇÃO</Link>
                    </div>

                    <div className="boxLinkVoltar">
                            <a href="/" id="mgPagInicial" className="lkMigalha"><span className="icon-left-open-2"></span> Página Inicial</a>
                    </div>
                </div>
        </div>
        );

    }
}